import { jsx as r } from "react/jsx-runtime";
import i from "@mui/material/Tab";
import n from "styled-components";
const s = {
  root: "tabRoot",
  labelIcon: "tabLabelIcon",
  selected: "tabSelected",
  disabled: "tabDisabled",
  wrapped: "tabWrapped",
  iconWrapper: "tabIconWrapper"
}, d = n(i).withConfig({
  displayName: "StyledTab"
})([
  "&&.tabRoot{min-height:48px;min-width:100px;max-width:unset;margin:0;background-color:",
  ";font-weight:",
  ";text-transform:none;line-height:1.2em;color:",
  ";padding:8px 16px;}&&.tabRoot:hover{background-color:",
  ";}&& svg{width:16px;height:16px;}&&.tabSelected{font-weight:",
  ";}&&.tabDisabled{color:",
  ";}"
], ({ theme: t }) => t.primaryBackground, ({ theme: t }) => t.typography.fontWeightRegular, ({ theme: t }) => t.text.primary, ({ theme: t }) => t.secondaryBackground, ({ theme: t }) => t.typography.fontWeightBold, ({ theme: t }) => t.secondaryDisabled), b = (t) => {
  const { classes: o, iconPosition: a = "start", ...e } = t;
  return /* @__PURE__ */ r(d, {
    ...e,
    iconPosition: a,
    classes: {
      ...s,
      ...o
    }
  });
};
export {
  b as default
};
